module.exports = __webpack_public_path__ + "static/media/about_banner.f566a977.png";